module.exports = require("lodash/hasIn");